// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2ADv-","number":"styles_number__3LWL0"};